import * as ActionType from '../actions/fleet-parade';

const defaultState = {isZoomPopupClosed: true, image: null};

/**
 * @description
 * Modal rules
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function fleetParade (state = defaultState, action) {
	let newState = {...state};

	switch (action.type) {

		case ActionType.DEACTIVATE_FLEET_PARADE : {
			newState.fleetParadeActive = false;
			return newState;
		}

		case ActionType.ACTIVATE_FLEET_PARADE : {
			newState.fleetParadeActive = true;
			return newState;
		}

		default:
			return state;
	}
}
